import {Effect, Loop} from '@mazechazer/redux-loop'
import {LoginFormAction} from '../Components/LoginForm/LoginFormActions'
import {loginFormReducer} from '../Components/LoginForm/LoginFormReducer'
import {update} from '../Data/ObjectHelper'
import {ChooseManufacturerAction} from '../Pages/ChooseManufacturer/ChooseManufacturerActions'
import {ChooseManufacturerFeedback} from '../Pages/ChooseManufacturer/ChooseManufacturerFeedback'
import {chooseManufacturerReducer} from '../Pages/ChooseManufacturer/ChooseManufacturerReducer'
import {InquiryDetailsAction} from '../Pages/InquiryDetails/InquiryDetailsActions'
import * as InquiryDetailsReducer
    from '../Pages/InquiryDetails/InquiryDetailsReducer'
import {InquiryOverviewAction} from '../Pages/InquiryOverview/InquiryOverviewActions'
import * as InquiryOverviewReducer
    from '../Pages/InquiryOverview/InquiryOverviewReducer'
import {OrderCreateAction} from '../Pages/OrderCreate/OrderCreateActions'
import * as OrderCreateReducer from '../Pages/OrderCreate/OrderCreateReducer'
import {OrderDetailsAction} from '../Pages/OrderDetails/OrderDetailsActions'
import * as OrderDetailsReducer from '../Pages/OrderDetails/OrderDetailsReducer'
import {OrderExportCreateAction} from '../Pages/OrderExportCreate/OrderExportCreateActions'
import * as OrderExportCreateReducer
    from '../Pages/OrderExportCreate/OrderExportCreateReducer'
import {OrderExportOverviewAction} from '../Pages/OrderExportOverview/OrderExportOverviewActions'
import * as OrderExportOverviewReducer
    from '../Pages/OrderExportOverview/OrderExportOverviewReducer'
import {OrderOverviewAction} from '../Pages/OrderOverview/OrderOverviewActions'
import * as OrderOverviewReducer
    from '../Pages/OrderOverview/OrderOverviewReducer'
import {PasswordChangeAction} from '../Pages/PasswordChange/PasswordChangeActions'
import * as PasswordChangeReducer
    from '../Pages/PasswordChange/PasswordChangeReducer'
import {PasswordLostAction} from '../Pages/PasswordLost/PasswordLostActions'
import {passwordLostReducer} from '../Pages/PasswordLost/PasswordLostReducer'
import {PrismaRequestDetailsAction} from '../Pages/PrismaRequestDetails/PrismaRequestDetailsActions'
import * as PrismaRequestDetailsReducer
    from '../Pages/PrismaRequestDetails/PrismaRequestDetailsReducer'
import {PrismaRequestOverviewAction} from '../Pages/PrismaRequestOverview/PrismaRequestOverviewActions'
import {prismaRequestOverviewReducer} from '../Pages/PrismaRequestOverview/PrismaRequestOverviewReducer'
import {ProductCalculationDetailsAction} from '../Pages/ProductCalculationDetails/ProductCalculationDetailsActions'
import * as ProductCalculationDetailsReducer
    from '../Pages/ProductCalculationDetails/ProductCalculationDetailsReducer'
import {ProductCalculationImportAction} from '../Pages/ProductCalculationImport/ProductCalculationImportActions'
import * as ProductCalculationImportReducer
    from '../Pages/ProductCalculationImport/ProductCalculationImportReducer'
import {ProductCalculationOverviewAction} from '../Pages/ProductCalculationOverview/ProductCalculationOverviewActions'
// tslint:disable-next-line max-line-length
import * as ProductCalculationOverviewReducer
    from '../Pages/ProductCalculationOverview/ProductCalculationOverviewReducer'
import {Action} from './Actions'
import {
    chooseManufacturerFeedbackReducer,
    reduceCreateOrderFeedback,
    reduceInquiryDetailsFeedback,
    reduceInquiryOverviewFeedback,
    reduceLoginFeedback,
    reduceOrderCreateExportFeedback,
    reduceOrderDetailsFeedback,
    reduceOrderOverviewExportFeedback,
    reduceOrderOverviewFeedback,
    reducePasswordChangeFeedback,
    reducePrismaRequestDetailsFeedback,
    reducePrismaRequestOverviewFeedback,
    reduceProductCalculationDetailsFeedback,
    reduceProductCalculationImportFeedback,
    reduceProductCalculationOverviewFeedback,
    reduceReloginFeedback
} from './FeedbackProcessing'
import {State} from './State'

export function reduceOrderCreateAction(
    state: State,
    subAction: OrderCreateAction
): Loop<State, Action> {
    if (state.type === 'Authenticated') {
        const page = state.page
        if (page.type === 'OrderCreatePage') {
            const feedbackLoop =
                OrderCreateReducer.reduce(
                    state.session,
                    page.state,
                    subAction,
                )
            const wrappedLoop = {
                state: update({
                    page: {
                        type: 'OrderCreatePage',
                        state: feedbackLoop.state
                    },
                }, state),
                effects: [],
            }
            return reduceCreateOrderFeedback(
                feedbackLoop.feedback,
                wrappedLoop)
        }
    }
    return {state, effects: []}
}

export function reduceOrderExportCreateAction(
    state: State,
    subAction: OrderExportCreateAction,
): Loop<State, Action> {
    if (state.type === 'Authenticated') {
        const page = state.page
        if (page.type === 'OrderExportCreatePage') {
            const feedbackLoop =
                OrderExportCreateReducer.reduce(
                    state.session,
                    page.state,
                    subAction,
                )
            const wrappedLoop = {
                state:
                    update(
                        {
                            page: {
                                type: 'OrderExportCreatePage',
                                state: feedbackLoop.state
                            },
                        },
                        state,
                    ),
                effects: [],
            }
            return reduceOrderCreateExportFeedback(
                feedbackLoop.feedback,
                wrappedLoop,
            )
        }
    }
    return {state, effects: []}
}

export function reduceOrderExportOverviewAction(
    state: State,
    subAction: OrderExportOverviewAction,
): Loop<State, Action> {
    if (state.type === 'Authenticated') {
        const page = state.page
        if (page.type === 'OrderExportOverviewPage') {
            const feedbackLoop =
                OrderExportOverviewReducer.reduce(page.state, subAction)
            const wrappedLoop = {
                state:
                    update(
                        {
                            page: {
                                type: 'OrderExportOverviewPage',
                                state: feedbackLoop.state
                            },
                        },
                        state,
                    ),
                effects: [],
            }
            return reduceOrderOverviewExportFeedback(
                feedbackLoop.feedback,
                wrappedLoop,
            )
        }
    }
    return {state, effects: []}
}

export function reducePasswordChangeAction(
    state: State,
    subAction: PasswordChangeAction
): Loop<State, Action> {
    if (state.type === 'Authenticated') {
        const page = state.page
        if (page.type === 'PasswordChangePage') {
            const
                feedbackLoop =
                    PasswordChangeReducer.reduce(page.state, subAction),
                wrappedLoop = {
                    state:
                        update(
                            {
                                page: {
                                    type: 'PasswordChangePage',
                                    state: feedbackLoop.state,
                                },
                            },
                            state,
                        ),
                    effects: [],
                }
            return reducePasswordChangeFeedback(
                feedbackLoop.feedback,
                wrappedLoop)
        }
    }
    return {state, effects: []}
}

export function reduceOrderDetailsAction(
    state: State,
    subAction: OrderDetailsAction
): Loop<State, Action> {
    if (state.type === 'Authenticated') {
        const page = state.page
        if (page.type === 'OrderDetailsPage') {
            const
                feedbackLoop =
                    OrderDetailsReducer.reduce(
                        state.session,
                        subAction,
                        page.state,
                    ),
                wrappedLoop = {
                    state:
                        update(
                            {
                                page: {
                                    type: 'OrderDetailsPage',
                                    state: feedbackLoop.state,
                                },
                            },
                            state,
                        ),
                    effects: [],
                }
            return reduceOrderDetailsFeedback(feedbackLoop.feedback, wrappedLoop)
        }
    }
    return {state, effects: []}
}

export function reduceOrderOverviewAction(
    state: State,
    subAction: OrderOverviewAction
): Loop<State, Action> {
    if (state.type === 'Authenticated') {
        const page = state.page
        if (page.type === 'OrderOverviewPage') {
            const
                feedbackLoop =
                    OrderOverviewReducer.reduce(
                        state.session,
                        subAction,
                        page.state,
                    ),
                wrappedLoop = {
                    state:
                        update(
                            {
                                page: {
                                    type: 'OrderOverviewPage',
                                    state: feedbackLoop.state,
                                },
                            },
                            state,
                        ),
                    effects: [],
                }
            return reduceOrderOverviewFeedback(feedbackLoop.feedback, wrappedLoop)
        }
    }
    return {state, effects: []}
}

export function reduceInquiryOverviewAction(
    state: State,
    subAction: InquiryOverviewAction,
): Loop<State, Action> {
    if (state.type === 'Authenticated') {
        const page = state.page
        if (page.type === 'InquiryOverviewPage') {
            const
                feedbackLoop =
                    InquiryOverviewReducer.reduce(
                        state.session,
                        page.state,
                        subAction,
                    ),
                wrappedLoop = {
                    state:
                        update(
                            {
                                page: {
                                    type: 'InquiryOverviewPage',
                                    state: feedbackLoop.state,
                                },
                            },
                            state,
                        ),
                    effects: [],
                }
            return reduceInquiryOverviewFeedback(feedbackLoop.feedback, wrappedLoop)
        }
    }
    return {state, effects: []}
}

export function reduceInquiryDetailsAction(
    state: State,
    subAction: InquiryDetailsAction,
): Loop<State, Action> {
    if (state.type === 'Authenticated') {
        const page = state.page
        if (page.type === 'InquiryDetailsPage') {
            const
                feedbackLoop =
                    InquiryDetailsReducer.reduce(
                        state.session,
                        page.state,
                        subAction,
                    ),
                wrappedLoop = {
                    state:
                        update(
                            {
                                page: {
                                    type: 'InquiryDetailsPage',
                                    state: feedbackLoop.state,
                                },
                            },
                            state,
                        ),
                    effects: [],
                }
            return reduceInquiryDetailsFeedback(feedbackLoop.feedback, wrappedLoop)
        }
    }
    return {state, effects: []}
}

export function reduceReloginAction(
    state: State,
    subAction: LoginFormAction
): Loop<State, Action> {
    if (state.type === 'Authenticated' && state.relogin !== null) {
        const
            feedbackLoop = loginFormReducer(state.relogin.modal, subAction),
            wrappedLoop: Loop<State, Action> = {
                state: update({
                    relogin: update({
                        modal: feedbackLoop.state,
                    }, state.relogin),
                }, state),
                effects: [],
            }
        return reduceReloginFeedback(
            feedbackLoop.feedback,
            wrappedLoop)
    } else {
        return {state, effects: []}
    }
}

export function reducePasswordLostAction(
    state: State,
    action: PasswordLostAction
): Loop<State, Action> {
    if (state.type === 'Public' && state.page.type === 'PasswordLostPage') {
        const loop = passwordLostReducer(state.page.state, action)
        return {
            state: update({
                page: {type: 'PasswordLostPage', state: loop.state},
            }, state),
            effects: loop.effects.map((effect: Effect<PasswordLostAction>): Effect<Action> =>
                effect.map((subAction: PasswordLostAction): Action =>
                    ({type: 'PasswordLostPageAction', subAction}))),
        }
    } else {
        return {state, effects: []}
    }
}

export function reduceLoginAction(
    state: State,
    action: LoginFormAction
): Loop<State, Action> {
    if (state.type === 'Public' && state.page.type === 'LoginPage') {
        const feedbackLoop = loginFormReducer(state.page.state, action)
        const updatedLoop: Loop<State, Action> = {
            state: update({
                page: {
                    type: 'LoginPage',
                    state: feedbackLoop.state,
                },
            }, state),
            effects: [],
        }
        return feedbackLoop.feedback.reduce(reduceLoginFeedback, updatedLoop)
    } else {
        return {state, effects: []}
    }
}

export function reduceChooseManufacturerAction(
    state: State,
    action: ChooseManufacturerAction
): Loop<State, Action> {
    if (state.type === 'ChoosingManufacturer' && state.page.type === 'ChooseManufacturerPage') {
        const feedbackLoop = chooseManufacturerReducer(
            state.intermediateSession, state.page.state, action)
        const updatedLoop = {
            state: update({
                page: {
                    type: 'ChooseManufacturerPage',
                    state: feedbackLoop.state,
                },
            }, state),
            effects: [],
        }
        const intermediateSession = state.intermediateSession
        return feedbackLoop.feedback.reduce(
            (
                previousLoop: Loop<State, Action>,
                feedback: ChooseManufacturerFeedback
            ) =>
                chooseManufacturerFeedbackReducer(
                    intermediateSession,
                    previousLoop,
                    feedback),
            updatedLoop)
    } else {
        return {state, effects: []}
    }
}

export function reduceProductCalculationOverviewAction(
    state: State,
    subAction: ProductCalculationOverviewAction,
): Loop<State, Action> {
    if (state.type === 'Authenticated') {
        const page = state.page
        if (page.type === 'ProductCalculationOverviewPage') {
            const
                feedbackLoop =
                    ProductCalculationOverviewReducer.reduce(
                        state.session,
                        page.state,
                        subAction,
                    ),
                wrappedLoop = {
                    state:
                        update(
                            {
                                page: {
                                    type: 'ProductCalculationOverviewPage',
                                    state: feedbackLoop.state,
                                },
                            },
                            state,
                        ),
                    effects: [],
                }
            return reduceProductCalculationOverviewFeedback(
                feedbackLoop.feedback,
                wrappedLoop,
            )
        }
    }
    return {state, effects: []}
}

export function reduceProductCalculationDetailsAction(
    state: State,
    subAction: ProductCalculationDetailsAction,
): Loop<State, Action> {
    if (state.type === 'Authenticated') {
        const page = state.page
        if (page.type === 'ProductCalculationDetailsPage') {
            const
                feedbackLoop =
                    ProductCalculationDetailsReducer.reduce(
                        state.session,
                        page.state,
                        subAction,
                    ),
                wrappedLoop = {
                    state:
                        update(
                            {
                                page: {
                                    type: 'ProductCalculationDetailsPage',
                                    state: feedbackLoop.state,
                                },
                            },
                            state,
                        ),
                    effects: [],
                }
            return reduceProductCalculationDetailsFeedback(
                feedbackLoop.feedback,
                wrappedLoop,
            )
        }
    }
    return {state, effects: []}
}

export function reduceProductCalculationImportAction(
    state: State,
    subAction: ProductCalculationImportAction,
): Loop<State, Action> {
    if (state.type === 'Authenticated') {
        const page = state.page
        if (page.type === 'ProductCalculationImportPage') {
            const
                feedbackLoop =
                    ProductCalculationImportReducer.reduce(
                        state.session,
                        page.state,
                        subAction,
                    ),
                wrappedLoop = {
                    state:
                        update(
                            {
                                page: {
                                    type: 'ProductCalculationImportPage',
                                    state: feedbackLoop.state,
                                },
                            },
                            state,
                        ),
                    effects: [],
                }
            return reduceProductCalculationImportFeedback(
                feedbackLoop.feedback,
                wrappedLoop,
            )
        }
    }
    return {state, effects: []}
}

export function reducePrismaRequestOverviewAction(
    state: State,
    subAction: PrismaRequestOverviewAction,
): Loop<State, Action> {
    if (state.type === 'Authenticated') {
        const page = state.page
        if (page.type === 'PrismaRequestOverviewPage') {
            const
                feedbackLoop =
                    prismaRequestOverviewReducer(
                        state.session,
                        page.state,
                        subAction,
                    ),
                wrappedLoop = {
                    state:
                        update(
                            {
                                page: {
                                    type: 'PrismaRequestOverviewPage',
                                    state: feedbackLoop.state,
                                },
                            },
                            state,
                        ),
                    effects: [],
                }
            return reducePrismaRequestOverviewFeedback(
                feedbackLoop.feedback,
                wrappedLoop,
            )
        }
    }
    return {state, effects: []}
}

export function reducePrismaRequestDetailsAction(
    state: State,
    subAction: PrismaRequestDetailsAction,
): Loop<State, Action> {
    if (state.type === 'Authenticated') {
        const page = state.page
        if (page.type === 'PrismaRequestDetailsPage') {
            const
                feedbackLoop =
                    PrismaRequestDetailsReducer.reduce(
                        state.session,
                        page.state,
                        subAction,
                    ),
                wrappedLoop = {
                    state:
                        update(
                            {
                                page: {
                                    type: 'PrismaRequestDetailsPage',
                                    state: feedbackLoop.state,
                                },
                            },
                            state,
                        ),
                    effects: [],
                }
            return reducePrismaRequestDetailsFeedback(
                feedbackLoop.feedback,
                wrappedLoop,
            )
        }
    }
    return {state, effects: []}
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/App/ReducerProcessing.ts